import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminCustomers() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/admin/customers").then(({ data }) => setList(data)); }, []);
  return (
    <div data-testid="admin-customers">
      <h1 className="font-display text-3xl text-[#49392F] mb-8">Clientes</h1>
      <div className="bg-white border border-[#C2A064]/20 overflow-x-auto">
        <table className="w-full text-[13px] min-w-[600px]">
          <thead className="text-left text-[#49392F]/70">
            <tr><th className="p-3">Nome</th><th className="p-3">E-mail</th><th className="p-3">WhatsApp</th><th className="p-3 text-right">Pedidos</th></tr>
          </thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan={4} className="p-6 text-center text-[#49392F]/60">Nenhum cliente ainda.</td></tr>}
            {list.map((u) => (
              <tr key={u.id} className="border-t border-[#C2A064]/10">
                <td className="p-3">{u.name}</td>
                <td className="p-3">{u.email}</td>
                <td className="p-3">{u.phone}</td>
                <td className="p-3 text-right">{u.orders_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
